import {useParams} from "react-router-dom";
import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {
    ContentCommentLikeValueObject
} from "../../../../data/value-object/content/ContentCommentLikeValueObject";
import {useEffect} from "react";
import {ContentCommentLikeIO} from "../../../../io/ContentIO";
import {Body1, Caption1Strong, Spinner} from "@fluentui/react-components";
import {mapByKey} from "../../../../util/ObjectUtil";
import {ContentCommentLikeDescription} from "../../../../data/description/content/ContentCommentLikeDescription";
import {ContentCommentLikeDomain} from "../../../../data/domain/content/ContentCommentLikeDomain";
import {ContentCommentLikeDescriptor} from "../../../../data/descriptor/content/ContentCommentLikeDescriptor";
import {DetailDefaultPanel, DetailDefaultTab} from "../../../DetailViews";
import {AssetLunarExchangeOptionIO} from "../../../../io/AssetIO";
import {
    AssetLunarExchangeOptionDescription
} from "../../../../data/description/asset/AssetLunarExchangeOptionDescription";

export default function Detail(props: RouterProps) {
    const params = useParams<{ contentCommentLikeId: string }>()
    const item = useStatePair<ContentCommentLikeValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.contentCommentLikeId !== undefined) {
            ContentCommentLikeIO
                .getById(BigInt(params.contentCommentLikeId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: ContentCommentLikeValueObject
}

function Page(props: PageProps) {
    return <>
        <div className={props.styles.row16}>
            <DetailDefaultTab {...props} />
            <DetailDefaultPanel
                {...props}
                client={ContentCommentLikeIO}
                description={ContentCommentLikeDescription}
                properties={props => <PropertyBody {...props} />}/>
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof ContentCommentLikeDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "createdAt":
            return <Body1>{ContentCommentLikeDescriptor[props.itemKey](props.item)}</Body1>
        case "userId":
            return <a href={`/users/${props.item.userId}`}><Body1>{ContentCommentLikeDescriptor[props.itemKey](props.item)}</Body1></a>
        case "contentCommentId":
            return <a href={`/contents/comments/${props.item.contentCommentId}`}><Body1>{ContentCommentLikeDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}